import React, {useEffect, useState} from "react";
import DataTable from "../../../components/data-table";
import Breadcrumbs from "../../../components/breadcrumbs";
import {useDispatch, useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import Button from "../../../components/button";
import Modal from "../../../components/modal";
import Input from "../../../components/input";
import LoadingSpinner from '../../../components/loading-spinner';
import CheckBox from "../../../components/check-box";

import {
    clear_product,
    createProduct,
    CREATE_PRODUCT,
    getAllProduct,
    updateProduct,
    UPDATE_PRODUCT
} from "../../../redux/products";
import {ToastContainer, toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import SelectInput from "../../../components/select";
import {getAllProductType} from "../../../redux/product_types";

const Product = (props) => {
    let history = useHistory();
    let dispatch = useDispatch();

    const {token} = useSelector((state) => state.users_module.login.data) || null;

    const _get_all_product = useSelector((state) => state.product_module._get_all_product);
    const _create_product = useSelector((state) => state.product_module._create_product);
    const _update_product = useSelector((state) => state.product_module._update_product);

    const _get_all_product_type = useSelector((state) => state.product_type_module._get_all_product_type);

    const [data, setData] = useState([]);
    const [product_types, setProductTypes] = useState([]);

    useEffect(() => {
        dispatch(getAllProduct(token));
    }, [token, dispatch]);

    useEffect(() => {
        if (_get_all_product && _get_all_product.data && _get_all_product.data.datos) {
            setData(_get_all_product.data.datos);
        }
    }, [_get_all_product]);

    useEffect(() => {
        if (_get_all_product_type && _get_all_product_type.data && _get_all_product_type.data.datos) {
            let array = _get_all_product_type.data.datos.filter(x => x.activo === true);
            setProductTypes(array);
        }
    }, [_get_all_product_type]);

    const [permisos, setPermisos] = useState([]);
    const [actions, setActions] = useState([]);
    const [modal, setModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [id, setId] = useState(0);

    const [form, setForm] = useState({
        descripcion: "",
        id_tipo: "",
        tipo: "",
        activo: true,
        id: 0
    });

    useEffect(() => {
        if (props) {
            const array = Object.values(props);
            setPermisos(array);
        }
    }, [props]);

    useEffect(() => {
        let act = []
        if (permisos) {
            if (permisos.filter(x => x.codigo === 'change_products').length > 0) {
                act.push({
                    name: "edit",
                    label: "Edit",
                    icon: "bx bx-edit",
                    color: "calendar",
                    onClick: (item) => {
                        dispatch(getAllProductType(token));
                        if (item.id_tipo === "") {
                            document.getElementById("id_tipo").selectedIndex = 0;
                        }
                        setId(item.id);
                        setForm({...form, descripcion: item.descripcion, id_tipo: item.id_tipo, tipo: item.tipo, activo: item.activo});
                        setModal(true);
                    },
                })
            }
        }
        setActions(act);
        // eslint-disable-next-line
    }, [permisos, history]);

    const handleChange = (e) => {
        if (e.target.name === 'activo') {
            setForm({
                ...form,
                [e.target.name]: e.target.checked,
            });
        } else if (e.target.name === 'id_tipo') {
            setForm({
                ...form,
                [e.target.name]: parseInt(e.target.value),
            });
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value,
            });
        }
    };

    useEffect(() => {
        if (_create_product.status === 201) {
            toast.success("Creado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_product(CREATE_PRODUCT));
            dispatch(getAllProduct(token));
            setIsLoading(false);
            setModal(false);
        } else if (_create_product.status !== 0) {
            dispatch(clear_product(CREATE_PRODUCT));
            toast.error(_create_product.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
    }, [_create_product, dispatch, history, token, id]);

    useEffect(() => {
        if (_update_product.status === 200) {
            toast.success("Actualizado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_product(UPDATE_PRODUCT));
            dispatch(getAllProduct(token));
            setIsLoading(false);
            setModal(false);
            setId(0);
        } else if (_update_product.status !== 0) {
            dispatch(clear_product(UPDATE_PRODUCT));
            toast.error(_update_product.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
    }, [_update_product, dispatch, history, token, id]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (form.descripcion === "") {
            toast.error("Debe ingresar la descripción", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (form.id_tipo === 0) {
            toast.error("Debe seleccionar el tipo de producto");
            setIsLoading(false);
            return;
        }
        if (id === 0) {
            dispatch(createProduct(token, form));
        } else {
            dispatch(updateProduct(token, id, form));
        }
    };

    return (
        <div className="app-content content">
            <div className="content-overlay"/>

            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Lista"
                            items={[{label: "Productos", link: "/productos"}]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div><ToastContainer/></div>
                    <div className="card">
                        <div className="card-content">
                            <div className="card-body">
                                {permisos.filter(x => x.codigo === 'add_products').length > 0 &&
                                    <Button type="button" text="Crear" theme="btn btn-success" onClick={() => {
                                        dispatch(getAllProductType(token));
                                        document.getElementById("id_tipo").selectedIndex = 0;
                                        setForm({...form, descripcion: '', id_tipo: '', tipo: ''});
                                        setId(0);
                                        setModal(true);
                                    }}/>
                                }
                                <div className="table-responsive">
                                    <DataTable
                                        dataTable={data}
                                        columns={[
                                            {
                                                name: "fecha_creacion",
                                                label: "Fecha de creación",
                                                type: "text",
                                            },
                                            {
                                                name: "descripcion",
                                                label: "Descripción",
                                                type: "text",
                                            },
                                            {
                                                name: "tipo",
                                                label: "Tipo",
                                                type: "text",
                                            },
                                            {
                                                name: "activo",
                                                label: "Activo",
                                                type: "boolean",
                                            },
                                        ]}
                                        actions={actions}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal className="modal-main div-modal" show={modal}>
                {isLoading && <LoadingSpinner/>}
                <div className="modal-content">
                    <div className="modal-header">
                        <h5>Producto</h5>
                    </div>
                    <div className="modal-body p-2">
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <Input
                                    id="descripcion"
                                    name="descripcion"
                                    label="Descripción"
                                    onChange={handleChange}
                                    value={form.descripcion}
                                />
                            </div>
                            <div className="form-group">
                                <label>Tipo</label>
                                <SelectInput
                                    label="Tipo"
                                    id="id_tipo"
                                    name="id_tipo"
                                    options={product_types.map((item) => ({
                                        name: item.descripcion,
                                        id: item.id,
                                    }))}
                                    select={form.tipo}
                                    onChange={handleChange}
                                />
                            </div>
                            {(id !== 0) &&
                                <div className="form-group">
                                    <CheckBox label="Activo" name="activo" id="activo" onChange={handleChange}
                                              state={form.activo}/>
                                </div>
                            }
                            <div className="text-center">
                                <button type="button" className="btn btn-outline-dark" onClick={() => {
                                    setModal(false);
                                    setId(0);
                                    setForm({
                                        descripcion: "",
                                        activo: true,
                                        id: id,
                                    })
                                }}> Cancelar
                                </button>
                                <Button type="submit" text="Guardar" theme="btn btn-success" classes="m-1"
                                        disabled={isLoading}/>
                            </div>
                        </form>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default Product;
